import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import { InitialState, Loading, Config, ErrorMessage, ErrorPopup, SuccessMessage } from './types';

const initialState: InitialState = {
  loading: {
    overlay: false,
    primaryAction: false,
  },
  config: {},
  successMessage: {
    primary: null,
    snackbar: null,
  },
  errorMessage: {
    primary: null,
    snackbar: null,
  },
  errorPopup: {
    open: false,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    triggerLoading(state, { payload }) {
      state.loading = { ...state.loading, ...(payload as Loading) };
    },
    setConfig(state, { payload }) {
      state.config = { ...state.config, ...(payload as Config) };
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = { ...state.errorMessage, ...(payload as ErrorMessage) };
    },
    setErrorPopup(state, { payload }) {
      state.errorPopup = { ...state.errorPopup, ...(payload as ErrorPopup) };
    },
    setSuccessMessage(state, { payload }) {
      state.successMessage = { ...state.successMessage, ...(payload as SuccessMessage) };
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
